const style = {};

style.mainColor = "#00BDD4";

style.btnBg = "#E8F7FA";
style.btnColor = "#304042";

style.addBtn = "#FF9B00";

style.genderMale = "#00B8EF";
style.genderFemale = "#EE0073";

export default style;
